import React, { useEffect, useState } from "react";

import { sortArray } from "../utils";
import RadioButton from "../RadioButton";

import cx from "classnames";
import styles from "./styles.module.scss";

const RadioButtonTable = ({
  className,
  name,
  question,
  questionIndex,
  required,
  updateUserData,
}) => {
  const [selectedOptions, setSelectedOptions] = useState({});
  const [mobileCollapsed, setMobileCollapsed] = useState({});

  useEffect(() => {
    if (
      question &&
      question.selects &&
      question.selects.length &&
      Object.keys(selectedOptions).length === 0
    ) {
      const selects = sortArray(question.selects, "order", "acs");

      const selectedOptions = {};
      for (let index = 0; index < selects.length; index++) {
        const rowKey = `col-row-${name}-${index}`;

        const value = selects[index].value.id;
        if (value) {
          selectedOptions[rowKey] = value;
        }
      }

      setSelectedOptions(selectedOptions);
    }
  }, [question]);

  const onMobileQuestionToggle = (rowKey) => {
    const newMobileCollapsed = {
      ...mobileCollapsed,
      [rowKey]: !mobileCollapsed[rowKey],
    };
    setMobileCollapsed(newMobileCollapsed);
  };

  const onChange = (rowKey, optionId, value) => {
    let reqData = {
      nextEntry: { id: optionId, value: true },
      type: "table",
    };

    if (selectedOptions[rowKey]) {
      reqData = { ...reqData, prevEntry: { id: selectedOptions[rowKey] } };
    }

    updateUserData(reqData);
    const newSelectedOptions = { ...selectedOptions, [rowKey]: value };
    setSelectedOptions(newSelectedOptions);
  };

  const desktopContainerCSS = cx(
    styles.RadioButtonTable,
    styles["RadioButtonTable--desktop"],
    className
  );
  const mobileContainerCSS = cx(
    styles.RadioButtonTable,
    styles["RadioButtonTable--mobile"],
    className
  );

  const selects = sortArray(question.selects, "order", "acs");
  if (!selects.length) {
    return <div />;
  }

  const options = sortArray(selects[0].options, "order", "acs");
  const numOfColumns = options.length + 1;

  const tableCSS = cx(
    styles.RadioButtonTable__table,
    styles[`RadioButtonTable__table--${numOfColumns}`]
  );

  const questionTitle = questionIndex
    ? `${questionIndex}. ${question.question}`
    : question.question;

  return (
    <>
      <div className={desktopContainerCSS}>
        <div className={styles.RadioButtonTable__question}>
          <span>{questionTitle}</span>
          {required && (
            <span className={styles.RadioButtonTable__requiredStar}>*</span>
          )}
        </div>
        <div className={tableCSS}>
          <div className={styles["RadioButtonTable__table--oddRow"]} />

          {options.map((option, index) => {
            const key = `col-header-${name}-${index}`;

            return (
              <div
                key={key}
                className={cx(
                  styles.RadioButtonTable__headerCell,
                  styles["RadioButtonTable__table--oddRow"]
                )}
              >
                {option.label}
              </div>
            );
          })}

          {selects.map((select, index) => {
            const rowKey = `col-row-${name}-${index}`;

            const backgroundCSS = cx({
              [styles["RadioButtonTable__table--oddRow"]]: index % 2 === 1,
              [styles["RadioButtonTable__table--evenRow"]]: index % 2 === 0,
            });

            return (
              <React.Fragment key={rowKey}>
                <div key={rowKey} className={backgroundCSS}>
                  {select.label}
                </div>
                {select.options.map((option, index2) => {
                  const radioKey = `radio-${name}-${index}-${index2}`;
                  const isChecked = selectedOptions[rowKey] === option.id;

                  return (
                    <RadioButton
                      key={radioKey}
                      id={radioKey}
                      className={cx(
                        backgroundCSS,
                        styles.RadioButtonTable__radioCell
                      )}
                      name={rowKey}
                      label=""
                      value={option.id}
                      checked={isChecked}
                      onChange={(value) => onChange(rowKey, option.id, value)}
                    />
                  );
                })}
              </React.Fragment>
            );
          })}
        </div>
      </div>
      <div className={mobileContainerCSS}>
        <div className={styles.RadioButtonTable__question}>
          {questionIndex}. {question.question}
        </div>
        {selects.map((select, index) => {
          const rowKey = `col-row-${name}-${index}`;
          const key = `mobile-table-${name}-${index}`;

          const radioButtonsContainer = cx(
            styles[`RadioButtonTable__mobileRadioContainer`],
            {
              [styles[`RadioButtonTable__mobileRadioContainer--visible`]]:
                !!mobileCollapsed[rowKey],
            }
          );

          return (
            <div className={styles.RadioButtonTable__mobileRadioBox} key={key}>
              <div
                className={styles.RadioButtonTable__subquestion}
                onClick={onMobileQuestionToggle.bind(null, rowKey)}
              >
                {select.label}
              </div>
              <div className={radioButtonsContainer}>
                {select.options.map((option, index2) => {
                  const radioKey = `mobile-radio-${name}-${index}-${index2}`;
                  const isChecked = selectedOptions[rowKey] === option.id;

                  return (
                    <RadioButton
                      key={radioKey}
                      id={radioKey}
                      className={styles.RadioButtonTable__radioCell}
                      name={`mobile-${rowKey}`}
                      label={option.label}
                      value={option.id}
                      checked={isChecked}
                      onChange={(value) => onChange(rowKey, option.id, value)}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RadioButtonTable;
